import { Notification } from '@crossfit/ui'
import toast from 'react-hot-toast'

export const useFormNotification = () => {
  const position = 'top-right'
  const stateToNotification = {
    info: 'Loading',
    success: 'Success',
    error: 'Error',
  }

  const toastDurationByType = {
    error: null,
    success: 2000,
    info: 1000,
  }

  return (
    notificationType: 'success' | 'error' | 'info',
    options?: { message?: string },
  ) => {
    const children = options?.message ?? stateToNotification[notificationType]

    toast.custom(
      (t) => (
        <Notification
          variant={notificationType}
          onClick={() => toast.remove(t.id)}
          style={{ fontSize: 16 }}
        >
          {children}
        </Notification>
      ),
      {
        position,
        duration: toastDurationByType[notificationType],
      },
    )
  }
}
